import { computed, ref, reactive, onBeforeMount } from "vue";
import { debounce } from "lodash-es";
import dayjs from "dayjs";

const useSearchForm = (props, emit) => {
  const isExpanded = ref(false);
  const formModel = reactive(props.data || {});
  const formData = computed(() => {
    return props.formData.filter((item) => !item.hidden);
  });

  const disabledDate = (date,number) => {
    return (
      date > Date.now() ||
      (number && date < dayjs().subtract(number, "month").startOf("month"))
    );
  };

  /* 限制小时 */
  const disabledHour = () => {
    const arrs = []
    for (let i = 0; i < 24; i++) {
      if (new Date().getHours() <= i) continue;
      arrs.push(i)
    }
    return arrs;
  }

  /* 限制分 */
  const disabledMinute = () => {
    const arrs = []
    for (let i = 0; i < 60; i++) {
      if (new Date().getMinutes() <= i) continue;
      arrs.push(i)
    }
    return arrs;
  }

  /* 限制秒 */
  const disabledSecond = () => {
    const arrs = []
    for (let i = 0; i < 60; i++) {
      if (new Date().getSeconds() <= i) continue;
      arrs.push(i)
    }
    return arrs;
  }

  const disabledWeek = (date) => {
    // 获取当前日期和星期几
    const today = new Date();
    const dayOfWeek = today.getDay();
    // 如果是星期天，则将 dayOfWeek 设为 7
    const sunDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    // 获取当前周的开始日期和结束日期
    const startDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - sunDayOfWeek + 1
    );
    const endDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + (7 - sunDayOfWeek)
    );
    // 获取待检查日期所在的周的开始日期
    const weekStartDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() - dayOfWeek + 1
    );
    // 如果待检查日期在当前周之前，则禁用该日期
    if (weekStartDate < startDate) {
      return true;
    }
    // 如果待检查日期在当前周之后，则禁用该日期
    // if (weekStartDate > endDate) {
    //   return true;
    // }
    // 否则不禁用该日期
    return false;
  };

  const search = () => {
    Object.entries(formModel).filter(([key, value])=>!props.allowEmpty.includes(key)).forEach(([key, value]) => {
      if (
        (typeof value === "string" && value.trim() === "") ||
        value === undefined
      ) {
        formModel[key] = undefined;
      }
    });

    formModel && emit("update:data", formModel);
    props.page &&
      emit("update:page", Object.assign(props.page, { pageNum: 1 }));
    emit("searchCallback", formModel);
  };
  const searchForm = ref();
  const reset = () => {
    props.formData
      .filter((item) => !props.noreset.includes(item.fieldName))
      .forEach((ele) => {
        if (ele.type === "datePicker") {
          formModel[ele.fieldName] = [dayjs(), dayjs()];
        } else {
          formModel[ele.fieldName] = undefined;
        }
      });
    emit("update:data", formModel);
    emit("resetCallback", formModel);
  };
  onBeforeMount(() => {
    // props.formData.forEach((ele) => {
    //     formModel[ele.fieldName] = undefined
    //     if (ele.type === "autocomplete") {
    //         ele?.vOn?.search("",ele)
    //     }
    // })
    emit("update:data", formModel);
    // initAndReset()
  });

  const formDataLength = computed(() => {
    return props.formData.filter((item) => !item.hidden).length;
  });

  const formItemWidth = computed(() => {
    const map = {
      1: 24,
      2: 12,
    };
    return map[formDataLength.value] || 8;
  });

  const searchFormFlex = computed(() => {
    return {
      flex: formDataLength.value === 2 ? 2 : 1,
    };
  });

  const searchEmptyFlex = computed(() => {
    const map = {
      1: 2,
      2: 1,
    };
    return {
      flex: map[formDataLength.value] || 0,
    };
  });

  const debounceInput = debounce((e, data) => {
    emit("formChange", data);
  }, 300);

  return {
    formItemFn(fieldName){
      return formData.value.find((item) => item.fieldName === fieldName)
    },
    formDataLength,
    formItemWidth,
    searchFormFlex,
    searchEmptyFlex,
    disabledHour,disabledMinute,disabledSecond,
    disabledDate,
    disabledWeek,
    formModel,
    formData,
    isExpanded,
    search,
    reset,
    debounceInput,
  };
};
export default useSearchForm;
